export default __webpack_public_path__ + "static/media/unplugged1.6fc3a2e9.svg";